import { type ConversationInventory } from '../../services/inventory-service';

export const getInventoryItemCategories = (
  inventory: ConversationInventory | undefined
): string[] => {
  if (!inventory) {
    return [];
  }

  return Object.entries(inventory)
    .filter(([, section]) => (section?.items?.length ?? 0) > 0)
    .map(([key]) => key);
};
